import React from "react";
import styles from "../Home.module.css"; // reuse or create your CSS module

export default function Report4({ goHome }) {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <h1>U.S. NAVAL AERO</h1>
          </div>

          <div>
            <h2>Field Maintenance Ledger — FA/18 Service Section</h2>
            <p className={styles.lead}>
            </p>
          </div>

          <div className={styles.headerRight}>
            <div className={styles.stamp}>CLASSIFIED — TECH ONLY</div>
            <div style={{ fontSize: "12px", marginTop: "6px" }}>Form: J-18-2015</div>
          </div>
        </header>

        <section className={styles.reports}>
          <article className={styles.report}>
            <div className={styles.meta}>
              <div className={styles.left}>
                <strong>Field Note / Incident:</strong> FA/18 — BuNo 94512
                <div style={{ fontSize: "12px", opacity: 0.9 }}>
                  Date: June 28, 2015 &nbsp; | &nbsp; Location: Auxiliary Airfield — Training Ops
                </div>
              </div>
              <div className={styles.right}>Observer: Lt. K. Rhodes</div>
            </div>

            <h3>Minor Ground Loop — Training Takeoff</h3>
            <table className={styles.log}>
              <thead>
                <tr>
                  <th>Sequence</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Event</td>
                  <td>During training takeoff, pilot reported sudden yaw on liftoff; aircraft returned to field and taxied to line under power.</td>
                </tr>
                <tr>
                  <td>Inspection</td>
                  <td>RH tailwheel linkage found with loosened actuating rod; no structural damage observed.</td>
                </tr>
                <tr>
                  <td>Action</td>
                  <td>Retorqued rod to 18 ft-lb; safety-wired clevis pin; pilot ground-check passed. Recommend follow-up alignment at next major service.</td>
                </tr>
              </tbody>
            </table>

            <div className={styles.note}>
              Pilot Statement (Lt. R. S.): "Felt a brief skid on liftoff; corrective inputs restored heading. No apparent injury to aircraft or crew."
            </div>

            <div className={styles.sig}>
              <div className={styles.signBlock}>
                <span className={styles.signature}>K. Rhodes</span>
                <div className={styles.initials}>Observing Officer</div>
              </div>
              <div style={{ textAlign: "right" }}>
                <span className={styles.scribble}>R. S. Manning</span>
                <div style={{ fontSize: "11px", color: "#554b3f" }}>Pilot — Training Squadron</div>
              </div>
            </div>
          </article>
        </section>

        <footer className={styles.footer}>
          <button
            onClick={() => goHome()}
            style={{
              cursor: "pointer",
              border: "none",
              background: "none",
              color: "var(--accent)",
              fontWeight: "bold"
            }}
          >
            ← Back to Home
          </button>
        </footer>
      </div>
    </div>
  );
}
